


















































































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import * as mdi from '@mdi/js';
import { AxStorage } from '@/storage';

@Component
export default class AxCardTitle extends Vue {
  mdi = mdi;

  @PropSync('visible', { type: Boolean }) $visible!: boolean;

  @Prop({ type: String, default: null })
  name?: string;

  @Prop({ type: String })
  color!: string;

  @Prop({ type: String })
  icon!: string;

  @Prop({ type: Boolean })
  small!: boolean;

  @Prop({ type: String })
  rightIcon!: string;

  @Prop({ type: Boolean, default: false })
  collapse!: boolean;

  created() {
    if (this.name) {
      this.$visible = AxStorage.getBoolean(this.keyName);
    }
  }

  onVisibleChanged() {
    this.$visible = !this.$visible;
  }

  get keyName() {
    return `ax-collapse-${this.name}`;
  }

  onEntireClick(e: HTMLElementEvent<HTMLDivElement>) {
    if (e.target.closest('button')) return;

    if (this.collapse) {
      const visible = !this.$visible;
      this.$visible = visible;

      if (this.name) {
        console.log('visible', visible);
        AxStorage.setBoolean(this.keyName, visible);
      }
    }
  }

  onRightIconClicked() {
    this.$emit('click');
  }

  get classVal() {
    const arr = [];
    if (this.small) arr.push('small');
    if (!this.icon) arr.push('no-icon');
    if (this.collapse) arr.push('collapse');
    return arr;
  }
}
